import { convertToLocalTime } from 'utils';
import { InfoBlock } from '../InfoBlock';
import { BidHistorySection } from 'pages/Shared/VehicleDetails/components';
import { BidHistoryProps } from './types';

export const AABids = ({ vehicle, initiallyCollapsed }: BidHistoryProps) => {
  const bids = vehicle.bids.map((bid: any) => ({
    id: bid.id,
    bid: bid.amount,
    bidder: bid.bidder?.dealership_name,
    date: convertToLocalTime(bid.created_at, true),
    created_at: bid.created_at
  }));

  return (
    <InfoBlock>
      <BidHistorySection
        auctionType={'autoaxess'}
        type={'bids'}
        initiallyCollapsed={initiallyCollapsed}
        bids={bids}
        proxyBid={vehicle.proxy_bid}
      />
    </InfoBlock>
  );
};
